// Mood → Radio Browser search config. Each mood maps to a single primary tag
// (Radio Browser's `tag` param is single-value; using tagList would require ALL
// tags to match). We pick the highest-yield tag for each mood.
export const MOODS = [
  {
    key: "late-night",
    label: "Late Night",
    subtitle: "Jazz · Lo-fi · Ambient",
    tag: "jazz",
    color: "cyan",
    icon: "moon",
    gradient: "from-cyan-500/20 to-blue-900/20",
  },
  {
    key: "morning",
    label: "Morning Wake",
    subtitle: "Pop · Breakfast · News",
    tag: "pop",
    color: "yellow",
    icon: "sunrise",
    gradient: "from-yellow-500/20 to-orange-900/20",
  },
  {
    key: "workout",
    label: "Workout",
    subtitle: "EDM · Hip-hop · House",
    tag: "electronic",
    color: "pink",
    icon: "flame",
    gradient: "from-pink-500/20 to-red-900/20",
  },
  {
    key: "focus",
    label: "Focus",
    subtitle: "Lo-fi · Classical · Ambient",
    tag: "classical",
    color: "cyan",
    icon: "brain",
    gradient: "from-cyan-500/20 to-indigo-900/20",
  },
  {
    key: "party",
    label: "Party",
    subtitle: "Dance · Latin · House",
    tag: "dance",
    color: "pink",
    icon: "party-popper",
    gradient: "from-pink-500/20 to-purple-900/20",
  },
  {
    key: "chill",
    label: "Chill",
    subtitle: "Chillout · Bossa · Soul",
    tag: "chillout",
    color: "green",
    icon: "waves",
    gradient: "from-green-500/20 to-cyan-900/20",
  },
  {
    key: "discovery",
    label: "Discovery",
    subtitle: "Random station worldwide",
    tag: null,
    random: true,
    color: "yellow",
    icon: "shuffle",
    gradient: "from-yellow-500/20 to-pink-900/20",
  },
  {
    key: "news",
    label: "News & Talk",
    subtitle: "News · Talk · Podcasts",
    tag: "news",
    color: "cyan",
    icon: "mic",
    gradient: "from-cyan-500/20 to-slate-900/20",
  },
];

export const DECADES = [
  { key: "60s", label: "60s", tag: "60s", color: "yellow" },
  { key: "70s", label: "70s", tag: "70s", color: "pink" },
  { key: "80s", label: "80s", tag: "80s", color: "cyan" },
  { key: "90s", label: "90s", tag: "90s", color: "green" },
  { key: "2000s", label: "2000s", tag: "2000s", color: "yellow" },
];

export function findMood(key) {
  return MOODS.find((m) => m.key === key) || null;
}
export function findDecade(key) {
  return DECADES.find((d) => d.key === key) || null;
}
